import React from 'react';
import { Form } from "react-bootstrap";

const CheckRadioInput = ({
    type = "checkbox", // Can be "checkbox" or "radio"
    id,
    name,
    label,
    checked,
    onChange,
    isInvalid = false,
    isValid = false,
    feedback = "",
    disabled = false,
    className = "",
    value,
    ...props
}) => {
    return (
        <Form.Group className={className} controlId={id}>
            <Form.Check
                type={type}
                id={id}
                name={name}
                label={label}
                checked={checked}
                onChange={onChange}
                isInvalid={isInvalid}
                isValid={isValid}
                disabled={disabled}
                value={value}
                {...props}
            />
            {feedback && (
                <Form.Control.Feedback type={isInvalid ? "invalid" : "valid"}>
                    {feedback}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    )
}

export default CheckRadioInput; 